import {useEffect} from 'react';
import {useInstance} from 'react-ioc';
import {useQuery} from '@apollo/client';
import {observer} from 'mobx-react-lite';

import {Store} from '../../model/store/Store';
import {getMoneyWwMe, getMoneyWwMeVariables} from '../../shared/graphql/__generated__/getMoneyWwMe';
import { QUERY_ME} from '../../shared/graphql/me';

export const Me = observer(() => {

    const {auth} = useInstance(Store)
    const query = useQuery<getMoneyWwMe,getMoneyWwMeVariables>(QUERY_ME, {
        variables: {token: auth.token!},
        pollInterval: 10000,
    })

    useEffect(() => {
        auth.setData(query.data?.getMoneyWwMe?.FIO!, auth.phone, null, query.data?.getMoneyWwMe?.paid!)
    }, [auth, query.data?.getMoneyWwMe?.FIO, query.data?.getMoneyWwMe?.paid])
    
    return null

})